import { render, staticRenderFns } from "./PhosphorusBalance.vue?vue&type=template&id=2c9d2284&lang=html&"
import script from "./PhosphorusBalance.vue?vue&type=script&lang=js&"
export * from "./PhosphorusBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports